






import Oidc from 'oidc-client';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class SilentCallback extends Vue {

    created() {
        new Oidc.UserManager({ userStore: new Oidc.WebStorageStateStore({}) })
            .signinSilentCallback()
            .then(() => {
                console.log('Silent redirect ok. Loading new user.');

            }).catch((err) => {
            console.log('Error in silent redirect:', err);
        });
    }
}
